<template>
  <div class="facebook-post-preview">
    <facebook-post-preview-header :pieces="pieces" :date="date" :profile="profile" />
    <facebook-post-preview-body-advanced v-if="!defaultView" :pieces="pieces" />
    <facebook-post-preview-body v-else :pieces="pieces" />
    <facebook-post-preview-footer />
  </div>
</template>

<script>
import FacebookPostPreviewHeader from './FacebookPostPreviewHeader.vue';
import FacebookPostPreviewBodyAdvanced from './FacebookPostPreviewBodyAdvanced.vue';
import FacebookPostPreviewBody from './FacebookPostPreviewBody.vue';
import FacebookPostPreviewFooter from './FacebookPostPreviewFooter.vue';

export default {
  components: {
    FacebookPostPreviewHeader,
    FacebookPostPreviewBody,
    FacebookPostPreviewBodyAdvanced,
    FacebookPostPreviewFooter,
  },
  props: {
    pieces: {
      type: Array,
      required: true,
    },
    date: {
      type: Number,
      required: true,
    },
    profile: Object,
    defaultView: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.facebook-post-preview {
  font-family: 'Roboto', sans-serif;
  border: 1px solid $color-mercury;
  box-shadow: 0px 0px 8px rgb(0 0 0 / 8%);
  border-radius: 8px;
}
</style>
